import { KOMCOL, MINCOL } from '../../../constants/const';
import ZeileLöschenVVD from '../../Datenerfassung/Bearbeitung/ZeileLöschenVVD';
import DeChecks from '../../Datenerfassung/DeChecks';
import CommentCellDatenerfassung from '../CommentCellDatenerfassung';
import EditableCell from '../EditableCell';
import DropdownFilter from '../SD_einsehen/DropdownFilter';

export const vvdHeader = [
    {accessor: 'jahr',
    Header: 'Jahr',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'vv_name',
    Header: 'Verkehrsvertrag',
    width: '30em',
        Filter: DropdownFilter},
    {accessor: 'zv_name',
    Header: 'Zweckverband',
    width: MINCOL,
        Filter: DropdownFilter},
    {accessor: 'erloes',
    Header: 'Erlösentgelt',
    Cell: EditableCell,
    width: '12em'},
    {accessor: 'trasse',
    Header: 'Trassenentgelt',
    Cell: EditableCell,
    width: '12em'},
    {accessor: 'station',
    Header: 'Stationsentgelt',
    Cell: EditableCell,
    width: '12em'},
    {accessor: 'status',
    Header: 'Status',
    width: MINCOL,
        Filter: DropdownFilter},
    {accessor: 'vv_id',
    Header: 'ID Verkehrsvertrag'},
    {accessor: 'vv_art',
    Header: 'Vertragsart',
    width: MINCOL},
    {
        accessor: 'kommentar',
        Header: 'Kommentar',
        width: KOMCOL,
        Cell: CommentCellDatenerfassung
    },
    {accessor: 'zv_id',
    Header: 'ID Zweckverband'},
    {accessor: 'statusEnum',
    Header: 'ID Status'},
    {accessor: 'checked',
    Header: 'Status ändern',
    Cell: DeChecks,
    width: MINCOL},
    {accessor: 'del',
    Header: 'Löschen',
    Cell: ZeileLöschenVVD
    }
];

export const vvdCsvHeader = [
    {key: 'code',
    label: 'Schluessel'},
    {key: "jahr",
    label: "Jahr"},
    {key: 'zv_name',
    label: "zugehoeriger ZV"},
    {key: "vv_name",
    label: "Verkehrsvertrag"},
    {key: "erloes",
    label: "Erloesentgelt"},
    {key: "trasse",
    label: "Trassenentgelt"},
    {key: "station",
    label: "Stationsentgelt"},
    {key: "status",
    label: "Status"},
];

export const hiddenColumns = ['vvd_id', 'vv_id', 'zv_id', 'statusEnum'];